<template>
    <b-card class="card-accent-light" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-file-lines"></i> <strong> CBB formulier </strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <cbbformulier-base :callback="createPatientCbbFormulier" borderless />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import CbbFormulierBase from './CbbFormulierBase'
import { mapActions } from "vuex"

export default ComponentExtension.extend({
    name: "cbb-formulier",
    components: {
        'cbbformulier-base': CbbFormulierBase
    },
    methods: {
        ...mapActions('health', ['createPatientCbbFormulier']),
    }
})
</script>
